import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "Icon",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m4.775-12.868a1 1 0 1 0-1.55-1.264L8.19 12.036l-1.504-1.418a1 1 0 1 0-1.372 1.456L7.6 14.228a1 1 0 0 0 1.46-.096z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }